__turbopack_context__.v({
  "holistic_career_carousel": "HolisticCareer-module-scss-module__VskTPW__holistic_career_carousel",
});
